<script
    context="module"
    lang="ts"
>
    export function changeStateOfSite(menuOn: boolean) {
        let siteContainer = document.body
        if (menuOn) siteContainer.style.overflow = "hidden"
        else siteContainer.style.overflow = "initial"
    }
</script>

<script lang="ts">
    import { mdiAccountOutline, mdiMenu, mdiShoppingOutline } from "@mdi/js"
    import { spaLink } from "../../actions"
    import Icon from "../widgets/Icon.svelte"
    import { icons } from "../../../config"
    import MobileMenu from "./MobileMenu.svelte"
    import { overlays } from "../../store"
    import { showCartOverlay } from "../../functions/helper/product"

    export let elements: NavigationElement[], bannerVisible: boolean, scrolled: boolean

    async function changeSubmenu(index: string | number) {
        changeStateOfSite(true)

        const submenuContainers = document.getElementsByClassName("submenu-container")
        Array.from(submenuContainers).forEach((container) => container.classList.remove("shown"))

        const invisibleMenu = document.getElementById(`submenu-${index}`)
        invisibleMenu.classList.add("shown")
        activeSubmenu = Number(index)
        let headerContainer = document.getElementById("header-container")
        headerContainer.classList.add("scrolled")
    }

    function closeSubmenu() {
        const submenuContainers = document.getElementsByClassName("submenu-container")
        Array.from(submenuContainers).forEach((container) => container.classList.remove("shown"))
        changeStateOfSite(false)
        activeSubmenu = -1
        if (window.scrollY < 100) {
            let headerContainer = document.getElementById("header-container")
            headerContainer.classList.remove("scrolled")
        }
    }
    let hoverTimeout: string | number | NodeJS.Timeout | undefined
    let hoverCloseTimeout: string | number | NodeJS.Timeout | undefined
    let isHoveringMenu = false
    function closeSubmenuWithTimeout() {
        hoverCloseTimeout = setTimeout(closeSubmenu, 200)
    }
    const openMenu = (i: number, page: NavigationElement) => {
        clearTimeout(hoverTimeout)
        if (page.elements.length) hoverTimeout = setTimeout(() => changeSubmenu(i), 500)
        else hoverTimeout = setTimeout(closeSubmenu, 500)
    }
    let activeSubmenu = -1
    $: if (isHoveringMenu) {
        clearTimeout(hoverCloseTimeout)
    }
</script>

<nav
    class="menu"
    class:scrolled="{scrolled}"
    class:not-scrolled="{!scrolled}"
    class:active="{activeSubmenu !== -1}"
    on:mouseover="{() => (isHoveringMenu = true)}"
    on:focus="{() => (isHoveringMenu = true)}"
    on:mouseleave="{() => (isHoveringMenu = false)}"
>
    <button
        id="burger-menu"
        class="mobile-burger"
        on:click="{() => {
            const overlay = {
                id: 'mobile-menu',
                title: 'Menu',
                active: true,
                content: MobileMenu,
                properties: {
                    elements,
                    bannerVisible,
                    scrolled,
                },
            }
            $overlays = [overlay]
        }}"
    >
        <Icon path="{mdiMenu}" />
    </button>
    <a
        href="/"
        use:spaLink
        class="logo-container"
        on:click="{closeSubmenu}"
    >
        {#if scrolled || activeSubmenu !== -1}
            <img
                src="../../../../logo/logo-blue.svg"
                alt="logo"
            />
        {:else}
            <img
                src="../../../../logo/logo-white.svg"
                alt="logo"
            />
        {/if}
    </a>
    <ul class="menuitem-container">
        {#each elements as page, i (i)}
            <li
                class="menu-item"
                class:active="{i == activeSubmenu}"
                on:mouseenter|stopPropagation="{() => openMenu(i, page)}"
                on:focus|stopPropagation="{() => openMenu(i, page)}"
                on:mouseleave|stopPropagation="{(e) => clearTimeout(hoverTimeout)}"
            >
                <div class="bar">
                    <span></span>
                    <img
                        src="../../../../media/BottomLeftCrinkleRed.svg"
                        alt="crinkle"
                    />
                </div>
                <a
                    href="{page.page}"
                    style="display: flex; flex-direction: column; align-items: center"
                    use:spaLink
                    on:mousedown="{closeSubmenu}"
                    ><div style="padding: 0px; line-height: 100%;">{page.name}</div>
                    {#if page.elements?.length}
                        <Icon
                            path="{icons.chevronDown}"
                            color="{scrolled ? '#2F4858' : '#F3EED9'}"
                            props="{{
                                'fill-rule': 'evenodd',
                                'clip-rule': 'evenodd',
                            }}"
                        />{/if}</a
                >
            </li>
        {/each}
    </ul>

    <ul class="icons-container">
        <li class="menu-item">
            <a
                href="/profile"
                use:spaLink><Icon path="{mdiAccountOutline}" /></a
            >
        </li>
        <li class="menu-item">
            <button on:click="{showCartOverlay}"><Icon path="{mdiShoppingOutline}" /></button>
        </li>
    </ul>
</nav>

{#each elements as submenu, i (submenu.name)}
    {#if submenu.elements?.length}
        <section
            role="menu"
            tabindex="0"
            on:mouseleave="{() => !isHoveringMenu && closeSubmenuWithTimeout()}"
            on:focus|stopPropagation
            class="submenu-container"
            id="{`submenu-${i}`}"
            style="top: 86px"
        >
            <ul class="sub-menu-columns">
                {#each submenu?.elements || [] as submenu_title, i (i)}
                    <li class="column">
                        <a
                            use:spaLink
                            href="{submenu_title.page}"
                            class="submenu-title"
                            class:bold="{submenu_title.elements.length}"
                            on:click="{closeSubmenu}">{submenu_title?.name}</a
                        >
                        {#if submenu_title.elements.length}
                            <ul class="sub-menu-rows">
                                {#each submenu_title?.elements || [] as submenu_point, i (i)}
                                    <li>
                                        <a
                                            use:spaLink
                                            href="{submenu_point.page}"
                                            class="submenu-endpoint"
                                            on:click="{closeSubmenu}">{submenu_point?.name}</a
                                        >
                                    </li>
                                {/each}
                            </ul>
                        {/if}
                    </li>
                {/each}
            </ul>
            <div class="img-placeholder"></div>
            <section class="image-wrapper">
                <div class="inner-wrapper">
                    <img
                        src="../../../../media/main-nav-pic.jpg"
                        alt="img"
                    />
                    <svg
                        width="10px"
                        height="50px"
                        viewBox="0 0 1 5"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <polygon
                            points="0,0 1,0 0,5"
                            fill="white"></polygon>
                    </svg>
                </div>
            </section>
        </section>
    {/if}
{/each}

<style lang="less">
    @import "../../assets/css/variables.less";
    .menu {
        max-width: var(--normal-max-width);
        width: 100%;
        display: flex;
        height: 86px;
        align-items: center;
        justify-content: space-between;
        &.not-scrolled a {
            color: var(--text-100);
        }
        &.active a {
            color: var(--text-invers-100);
        }
        .logo-container {
            height: 64px;
            display: flex;
            align-items: flex-start;
            img {
                height: 60px;
                width: auto;
                object-fit: contain;
            }
        }
        @media @desktop {
            #burger-menu {
                display: none;
            }
        }
        .menuitem-container {
            display: flex;
            height: 100%;
            justify-content: flex-start;
            align-items: flex-end;
            width: fit-content;
            gap: 1.2rem;
            padding-top: 0.55rem;
            height: 100%;
            .menu-item {
                height: 50px;
                padding: 0px 1.2rem 0.6rem 1.2rem;
                position: relative;
                .bar {
                    display: flex;
                    opacity: 0;
                    position: absolute;
                    top: -12px;

                    left: 0;
                    right: 0;
                    justify-content: flex-end;
                    span {
                        background-color: var(--primary-100);
                        flex-grow: 1;
                        margin-right: -2px;
                    }
                    img {
                        width: 12.169px;
                        height: 12px;
                    }
                }
                &.active {
                    .bar {
                        opacity: 1;
                    }
                    a {
                        color: var(--text-100);
                    }
                    background-color: var(--primary-100);
                }
            }
            @media @max-tablet {
                display: none;
            }
        }
        .icons-container {
            display: flex;
            justify-content: flex-end;
            gap: 1.2rem;
        }
    }

    .submenu-container {
        min-height: 22.3rem;
        min-width: 100vw;
        border-top: 4px solid var(--primary-100);
        height: fit-content;
        z-index: 1000;
        max-width: var(--normal-max-width);
        background-color: var(--neutral-white);
        display: flex;
        justify-content: center;
        left: -100vw;
        transition: left 300ms, opacity 300ms;
        opacity: 0;
        position: absolute;
        :global &.shown {
            opacity: 1 !important;
            left: 0px !important;
            right: 0px;
        }
        .sub-menu-columns {
            padding: 2.4rem 0rem;
            display: flex;
            align-items: start;
            gap: 2.4rem;
            flex-wrap: wrap;
            .column {
                display: flex;
                flex-direction: column;
                min-width: 180px;
                gap: 1.2rem;
                .submenu-title {
                    &.bold {
                        text-transform: uppercase;
                        font-weight: 700;
                        font-style: Outfit-bold, sans-serif;
                    }
                }
                .sub-menu-rows {
                    display: flex;
                    flex-direction: column;
                    gap: 0.9rem;
                    li {
                        .submenu-endpoint {
                            font-weight: 400 !important;
                            font-style: Outfit-normal, sans-serif !important;
                        }
                    }
                }
            }
        }
        .img-placeholder {
            height: 100%;
            width: 100%;
            max-width: 55%;
        }

        .image-wrapper {
            position: absolute;
            right: 0px;
            max-width: 50%;
            height: 100%;

            .inner-wrapper {
                position: relative;
                height: 100%;
                width: 100%;

                img {
                    height: 100%;
                    object-fit: cover;
                }

                svg {
                    position: absolute;
                    top: 0;
                    left: 0;

                    height: 100%;
                    width: auto;
                    opacity: 1;
                }
            }
        }
    }
</style>
